<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.setor"
        ref="DataTable"
        sort-by="tipo"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-setor-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-setor"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-setor"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories.setor = this.getConectaSusRepository('cadastro.estabelecimento.setor')
    },
    data: () => ({
        fields: [
            {
                name: 'cadastroSetorTipo.nome',
                key: 'tipo',
                label: 'Tipo',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroServico.nome',
                key: 'servico',
                label: 'Serviço',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroSetor.nome',
                key: 'nome',
                label: 'Nome',
                searchable: true,
                sortable: true
            },
            {
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            setor: null,
        },
    }),
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.setor.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o setor?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>